var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M3 11H1v-1h14v1h-2v3h1v1H2v-1h1v-3zm1 0v3h2v-3H4zm3 0v3h2v-3H7zm3 0v3h2v-3h-2zM3.198 6.618L4.5 2.973l1.302 3.645c-.454.263-.886.388-1.302.388-.416 0-.848-.125-1.302-.388zM4.694 8H5v2H4V8h.306C3.538 7.952 2.77 7.619 2 7h5c-.769.619-1.538.952-2.306 1zM10 6h3V4a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2zm1-4h1a2 2 0 0 1 2 2v3H9V4a2 2 0 0 1 2-2z" })
  );
});